import trackMainGallerySlideView from '../track-event/main-gallery-slide-view';
import trackMainGallerySlideOpen from '../track-event/main-gallery-slide-open';
import trackMainGallerySlideClose from '../track-event/main-gallery-slide-close';
import trackMainGallerySlideInaction, { EVENT_NAME as SCREENSHOT_INACTION_EVENT_NAME } from '../track-event/main-gallery-slide-inaction';
import galleryTracker from './_gallery';



export default galleryTracker({
  SCREENSHOT_INACTION_EVENT_NAME,
  trackSlideView: trackMainGallerySlideView,
  trackSlideOpen: trackMainGallerySlideOpen,
  trackSlideClose: trackMainGallerySlideClose,
  trackSlideInaction: trackMainGallerySlideInaction
});



// WEBPACK FOOTER //
// ./src/lib/bind-event-tracking/main-gallery.js